var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <span data-label-title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelTitle") : stack1), depth0))
    + "\"\n          data-label-choose=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelChoose") : stack1), depth0))
    + "\"\n          data-label-selected=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelSelected") : stack1), depth0))
    + "\"\n          data-label-option=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelOption") : stack1), depth0))
    + "\"\n          data-label-options=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelOptions") : stack1), depth0))
    + "\" js-select-title>\n        "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelTitle") : stack1), depth0))
    + "\n    </span>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <span data-label-title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelTitle") : stack1), depth0))
    + "\" js-select-title>\n        "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelTitle") : stack1), depth0))
    + "\n    </span>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li class=\"select-search\">\n        <input type=\"search\" placeholder=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelSearch") : stack1), depth0))
    + "\" js-select-search />\n        <svg>\n            <use xlink:href=\"/images/securitas.spritemap.svg#sprite-search\"></use>\n        </svg>\n    </li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li class=\"disabled\">\n        <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelTitle") : stack1), depth0))
    + "</span>\n    </li>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"multiple") : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":15},"end":{"line":45,"column":49}}})) != null ? stack1 : "")
    + "\"\n        role=\"option\"\n        aria-checked=\"false\"\n        tabindex=\"0\"\n        title=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"textValue") : depth0), depth0))
    + "\"\n        data-select-text=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"textValue") : depth0), depth0))
    + "\"\n        data-select-lang=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"lang") : depth0), depth0))
    + "\"\n        data-select-value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"value") : depth0), depth0))
    + "\" js-select-item>\n        <span>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"textValue") : depth0), depth0))
    + "</span>\n    </li>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "multiple";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"select-no-hits\">\n            <svg><use xlink:=\"\" href=\"/images/securitas.spritemap.svg#sprite-remotion-info\"></use></svg>\n            <h4>"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelNohitstitle") : stack1), depth0))
    + "</h4>\n            <p>"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"labels") : depth0)) != null ? lookupProperty(stack1,"labelNohitstext") : stack1), depth0))
    + "</p>\n        </li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"select-toggle\" tabindex=\"0\" data-multiple=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"multiple") : depth0), depth0))
    + "\" js-select-toggle>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"multiple") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0, blockParams, depths),"inverse":container.program(1, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":14,"column":11}}})) != null ? stack1 : "")
    + "\n    <svg>\n        <use xlink:href=\"/images/securitas.spritemap.svg#sprite-chevron-down\"></use>\n    </svg>\n</button>\n\n<button class=\"clear-filter\" js-clear-filter>\n    <svg>\n        <use xlink:href=\"/images/securitas.spritemap.svg#sprite-close--blue\"></use>\n    </svg>\n</button>\n\n\n<ul class=\"select-panel\" role=\"listbox\" js-select-panel>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"searchable") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":4},"end":{"line":36,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"multiple") : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":4},"end":{"line":42,"column":15}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":4},"end":{"line":55,"column":13}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"noResults") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":4},"end":{"line":63,"column":11}}})) != null ? stack1 : "")
    + "</ul>";
},"useData":true,"useDepths":true});